<template>
  <div v-if="selectedTableId">
    <!--    <b-badge v-for="field in selectedTable.fields" :key="field.name" variant="primary" class="mr-2"-->
    <!--             @click="addFilter(field.name)">-->
    <!--      {{ field.name }} | {{ field.type }}-->
    <!--    </b-badge>-->
    <div class="mb-2">
      <span class="invisible">-</span>
      <b-button class="btn-add-filter" size="sm" variant="outline-primary" @click="showSelectColumnModal">Add filter
      </b-button>
    </div>
    <div class="p-2">
      <div v-for="filter in filters" :key="filter.columnName">
        <b-row class="mt-3">
          <b-col cols="1">
          <span
              v-if="!filter.isLoading"
              class="clickable align-middle"
              @click="removeFilter(filter)"
          >
            <b-icon-x/>
          </span>
            <b-spinner
                v-if="filter.isLoading"
                small
                variant="primary"
                label="Spinning"
            ></b-spinner>
          </b-col>
          <b-col cols="4" xl="2" lg="3">
            <span class="filter-label mt-1">{{ filter.columnName }}</span>
          </b-col>
          <b-col cols="7" xl="9" lg="8">
            <div v-if="filter.type === 'STRING'">
              <bq-filter-select
                  v-model="filter.selectedValues"
                  :values="filter.values"
                  :is-loading="filter.isLoading"
                  :approx-count="filter.approxDistinctCount"
                  @search="(searchText) => {searchFilter(filter, searchText);} "
              />
            </div>
            <div v-else-if="filter.type === 'DATE'">
              <bq-filter-date-range v-model="filter.selectedValues"/>
            </div>
            <div v-else-if="filter.type === 'DATETIME'">
              <bq-filter-date-time-range v-model="filter.selectedValues"/>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <div v-if="userSelectedColumns.length" class="mb-3">
      <!--      <bq-filter-fields v-model="selectedColumns" :columns="selectedTableColumns"/>-->
      <bq-filter-columns v-model="sortedColumns"/>
    </div>

    <b-modal ref="selectColumnModal" hide-header hide-footer centered @hidden="clearSearchField">
      <b-form @submit.prevent.stop="addFilter">
        <b-form-group label="Search:">
          <b-form-input
            v-model="searchQuery"
            size="sm"
            placeholder="Search columns..."
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Columns:">
          <b-form-select
            :select-size="8"
            size="sm"
            :options="filteredFields"
            v-model="currentSelectedColumn"
            value-field="name"
            required
            @change="selectedFilter"
          ></b-form-select>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
// import axios from "axios";
import _ from 'lodash';
import BqFilterSelect from "./BqFilterSelect.vue";
import BqFilterDateRange from "./BqFilterDateRange.vue";
import BqFilterDateTimeRange from "./BqFilterDateTimeRange.vue";
import dayjs from "dayjs";
import BqFilterColumns from "./BqFilterColumns.vue";
import dataGrabberServices from "@/DataGrabberServices";

export default {
  name: "BqFilterHandler",
  components: {BqFilterColumns, BqFilterDateRange, BqFilterSelect,BqFilterDateTimeRange},
  props: {
    value: {
      type: Object,
      default() {
        return {
          reference: {},
          filters: []
        };
      }
    },
    datasourceId: {type: Number},
    selectedTable: {
      type: Object,
      default() {
        return {
          fields: [{
            name: '', type: ''
          }],
        }
      }
    },
    userSelectedColumns: {type: Array},
    brands: {type: Array}
  },
  mounted() {
    this.initializeData();
    this.emitInput();
  },
  watch: {
    selectedTable: {
      deep: true,
      handler() {
        this.initializeData();
        this.emitInput();
      }
    },
    filters: {
      deep: true,
      handler() {
        this.emitInput();
      }
    },
    sortedColumns: {
      deep: true,
      handler() {
        this.emitInput();
      }
    },
    userSelectedColumns: {
      deep: true,
      handler() {
        this.sortedColumns = this.userSelectedColumns
        this.emitInput();
      }
    }
  },
  data() {
    return {
      filters: [],
      currentSelectedColumn: '',
      sortedColumns: [],
      searchQuery: '',
    }
  },
  computed: {
    sortedFields() {
      let fields = [...this.selectedTable.fields];

      //only takes STRING and DATE and DATETIME type
      fields = _.filter(fields, (field) => {
        const filterableTypes = ['STRING', 'DATE', 'DATETIME']
        return filterableTypes.includes(field.type);
      });

      //filter out fields that already been selected
      fields = _.filter(fields, (field) => {
        return !_.find(this.filters, (filter) => {
          return filter.columnName === field.name
        })
      });
      
      //add in html display
      fields = _.map(fields, (field => {
        return {...field, ...{text: `${field.name} (${field.type.toLowerCase()})`}}
      }));

      return _.orderBy(fields, ['type', 'name']);
    },
    dataset() {
      return this.selectedTable.reference.datasetId
    },
    selectedTableId() {
      if (this.selectedTable && this.selectedTable.reference) {
        return this.selectedTable.reference.tableId;
      }
      return '';
    },
    selectedTableColumns() {
      if (this.selectedTable && this.selectedTable.fields) {
        // return _.map(this.selectedTable.fields, (f) => {
        //   return f.name;
        // });
        return [...this.selectedTable.fields];
      }
      return [];
    },
    filteredFields() {
        const query = this.searchQuery.toLowerCase();
        return this.sortedFields.filter((field) =>
            field.name.toLowerCase().includes(query)
        );
    }
  },
  methods: {
    initializeData() {
      this.filters = this.filters.length ? this.filters : [];
      this.sortedColumns = this.sortedColumns.length ? this.sortedColumns : this.userSelectedColumns;
      this.currentSelectedColumn = '';
    },
    async selectedFilter() {
      this.$refs['selectColumnModal'].hide();
      const columnName = this.currentSelectedColumn;
      await this.addNewFilter({columnName: columnName, selectedValues: []})
    },
    emitInput() {
      // const fields = [...this.selectedTable.fields];
      // const selectedColumns = _.map(this.selectedColumns, (c) => {
      //   let field = _.find(fields, {name: c});
      //   return {
      //     name: field.name,
      //     type: field.type
      //   };
      // });
      const sortedColumns = [...this.sortedColumns];

      const filters = _.map(this.filters, (filter) => {
        return {
          field: {
            name: filter.columnName,
            type: filter.type
          },
          selectedValues: filter.selectedValues
        };
      });

      this.$emit('input', {
        reference: {...this.selectedTable.reference},
        filters: filters,
        columns: sortedColumns
      });
    },
    showSelectColumnModal() {
      // this.currentSelectedColumn = this.sortedFields[0].name;
      this.currentSelectedColumn = null;
      this.$refs['selectColumnModal'].show();
    },
    removeFilter(filter) {
      this.filters = _.filter(this.filters, (f) => {
        return f.columnName !== filter.columnName
      });
    },
    async addFilter() {
      const columnName = this.currentSelectedColumn;
      await this.addNewFilter({columnName: columnName, selectedValues: []})
    },

    async addNewFilter({columnName, selectedValues}) {
      const fields = [...this.selectedTable.fields]
      const selectedField = _.find(fields, {name: columnName});
      const filter = {
        columnName: columnName,
        values: [],
        selectedValues: selectedValues,
        isLoading: true,
        type: selectedField.type,
        approxDistinctCount: selectedField.approxDistinctCount
      }
      this.filters.push(filter);
      if (filter.type === 'STRING') {
        const values = await this.getColumnDistinctValues(columnName);
        filter.values = _.filter(values, (v) => {
          return Boolean(v);
        });
        if (columnName.toLowerCase() === this.selectedTable.brandColumn.toLowerCase())
          filter.values = _.filter(filter.values, (v) => {
            return this.brands.includes(v);
          });

      } else if (filter.type === 'DATE') {
        filter.selectedValues = [dayjs().format(DATE_FORMAT), dayjs().format(DATE_FORMAT)];
      }
      filter.isLoading = false;
    },

    async getColumnDistinctValues(columnName) {
      this.isBusy = true;
      const filter = _.find(this.filters, {columnName: columnName});
      filter.isLoading = true;
      const tableId = this.selectedTableId;
      const response = await dataGrabberServices.getColumnDistinctValues(this.datasourceId, this.dataset, tableId, columnName);
      // const response = await axios.get(`api/bigQuery/datasets/${this.dataset}/column-distinct-values`, {
      //   params: {
      //     tableId: tableId,
      //     columnName: columnName
      //   }
      // });
      this.isBusy = false;
      filter.isLoading = false;
      return response.data;
    },
    async searchFilter(filter, searchText) {
      this.isBusy = true;
      filter.isLoading = true;
      const tableId = this.selectedTableId;
      const response = await dataGrabberServices.getColumnDistinctValues(this.datasourceId, this.dataset, tableId, filter.columnName, searchText);
      // let response = await axios.get(`api/bigQuery/datasets/${this.dataset}/column-distinct-values`, {
      //   params: {
      //     tableId: tableId,
      //     columnName: filter.columnName,
      //     searchText: searchText
      //   }
      // });
      const selectedValues = [...filter.selectedValues];
      const newValues = [...response.data];
      filter.values = _.uniq([...selectedValues, ...newValues]);
      this.isBusy = false;
      filter.isLoading = false;
    },
    clearSearchField() {
      this.searchQuery = '';
    },
  }
}

const DATE_FORMAT = 'YYYY-MM-DD';
</script>

<style scoped>
.filter-label {
  display: inline-block;
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-container {
  padding: 0.5rem 0.5rem 0.25rem;
}

.btn-add-filter {
  position: absolute;
  left: 1rem;
  top: 0.25rem;
}
</style>